import axios from 'axios';
import { v4 as uuid } from 'uuid';
import config from '../../config';

class FormSubmissionHandler {
  constructor(formComponent) {
    this.form = formComponent;
  }

  async submitForm(reqId, answer_data) {
    let usageDataMapping = new FormData();
    const usageMapping = {};
    usageMapping.formId = this.form.state.form_id;
    usageMapping.sessionId = this.form.props.match.params.session_id;
    usageMapping.status = 'PROCESS';
    let FormDataSubmission = new FormData();
    const formSubmission = {};
    formSubmission.formId = this.form.state.form_id;
    formSubmission.upload = [];
    const isTest = this.form.props.match.params.test_id !== undefined;

    for (var obj in answer_data) {
      if (
        answer_data[obj].answer &&
        answer_data[obj].answer[0] instanceof File
      ) {
        formSubmission.upload.push({
          key: answer_data[obj].key,
          answer: [],
          question_text: answer_data[obj].question_text,
        });
        FormDataSubmission.append('file', answer_data[obj].answer[0]);
        delete answer_data[obj];
      }
    }
    const req_id = reqId || uuid();
    usageMapping.reqId = req_id;
    var idToken = await this.form.processIdToken();

    if (answer_data && answer_data.project_name) {
      usageMapping.displayName = answer_data.project_name.answer[0];
    }
    usageMapping.displayName = this.form.getDisplayName(answer_data);

    formSubmission.data = answer_data;
    this.form.setState({ req_id: req_id });
    FormDataSubmission.append('data', JSON.stringify(formSubmission));
    FormDataSubmission.append('req_id', req_id);
    FormDataSubmission.append(
      'submissionUrl',
      this.form.props.form.submissionUrl
    );
    FormDataSubmission.append('sessionID', usageMapping.sessionId);
    FormDataSubmission.append(
      'projectSessionId',
      this.form.state.projectSessionId || this.form.props.form.projectSessionId
    );

    FormDataSubmission.append('projectId', this.form.state.projectId);
    FormDataSubmission.append('projectVersion', this.form.state.projectVersion);

    // Set thread
    FormDataSubmission.append('parentThreadId', this.form.state.parentThreadId);
    FormDataSubmission.append('threadId', this.form.state.threadId);

    let formSessionURL =
      'https://form.workflow86.com/form/' +
      this.form.state.form_id +
      '/' +
      this.form.props.match.params.session_id;

    if (isTest) {
      FormDataSubmission.append('projectSessionMode', 'TEST');
      FormDataSubmission.append(
        'projectTestId',
        this.form.props.match.params.test_id
      );
      FormDataSubmission.append('latestTestProjectSessionId', req_id);

      formSessionURL =
        'https://form.workflow86.com/form/form_test/' +
        this.form.state.form_id +
        '/' +
        this.form.props.match.params.test_id +
        '/' +
        this.form.props.match.params.session_id;
    }

    FormDataSubmission.append('formSessionURL', formSessionURL);

    // Set the waiting state thread
    FormDataSubmission.append(
      'waitingStateThreadId',
      this.form.state.waitingStateThreadId
    );
    FormDataSubmission.append(
      'waitingStateParentThreadId',
      this.form.state.waitingStateParentThreadId
    );

    FormDataSubmission.append('isSingleUse', this.form.state.isSingleUse);
    FormDataSubmission.append('formType', this.form.state.formType);

    let usagePromise = Promise.resolve(1);

    if (config.USAGE_ADDRESS && config.USAGE_ADDRESS != '') {
      usagePromise = axios
        .post(`${config.USAGE_ADDRESS}/usage`, JSON.stringify(usageMapping), {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: idToken,
          },
        })
        .catch((e) => {
          console.log('Error during call to Usage Service ' + e);
        });
    }
    return await usagePromise.then(() => {
      return axios
        .post(`${config.API_ADDRESS}/form_submit`, FormDataSubmission, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'multipart/form-data',
            Authorization: idToken,
          },
        })
        .then((res) => {
          this.handleAfterFormSubmit();

          if (isTest) {
            this.form.setState({
              testResult: {
                createdAt: new Date(),
                projectSessionId: reqId,
              },
            });
          }
        })
        .catch((e) => {
          this.form.setState((state) => {
            return {
              receiptState: 'failure',
              sended: false,
              response: true,
              finished: true,
              isSubmitting: false,
            };
          });
          throw e;
        });
    });
  }

  handleAfterFormSubmit = async () => {
    // Check for external URL redirect first
    if (this.form.state.redirectToExternalUrl && this.form.state.redirectUrl) {
      return this.form.setState((state) => {
        return {
          sended: false,
          response: true,
          finished: true,
          isSubmitting: false,
          receiptState: 'redirecting',
        };
      });
    }

    // If there's a linkedComponent, prioritize redirect over readonly/canEdit conditions
    if (this.form.state.linkedComponent) {
      return this.form.setState((state) => {
        return {
          sended: false,
          response: true,
          finished: true,
          isSubmitting: false,
          receiptState: 'hidden',
        };
      });
    }

    // If no linkedComponent, check readonly/canEdit conditions
    if (
      this.form.state.trueCanReadOnly ||
      this.form.state.canReadOnly ||
      this.form.state.canEditSubmission
    ) {
      // Need to show dialog
      return this.form.setState((state) => {
        return {
          sended: false,
          response: true,
          finished: true,
          isSubmitting: false,
          showSubmissionDialog: true,
          canReadOnly:
            this.form.state.trueCanReadOnly || this.form.state.canReadOnly,
          hasBeenSubmitted: true,
          showResubmitDialog: false,
        };
      });
    }

    // Default case - no linkedComponent and no readonly/canEdit restrictions
    else {
      // Need to redirect to finish receipt
      return this.form.setState((state) => {
        return {
          sended: false,
          response: true,
          finished: true,
          isSubmitting: false,
          receiptState: 'success',
        };
      });
    }
  };

  async handleSubmit() {
    // Handle Submit
    this.form.setState({ isSubmitting: true });
    const { answer_data } = this.form.props.form;
    this.form.clearDeletedFields();

    if (this.form.isAuthenticated() === false) {
      this.form.setState({ authState: 'signIn', isSubmitting: false });
    } else {
      if (this.form.checkAllAnswered() == false) {
        // Don't override the state that was just set by checkAllAnswered
        // Just update the isSubmitting flag
        this.form.setState({ isSubmitting: false });
        return;
      }

      try {
        this.form.setState((state) => {
          return {
            currentStep: 0,
            processD: true,
            sended: true,
          };
        });
        const reqId = uuid();
        this.form.setState({ pageProcessing: true });

        if (
          !this.form.props.match.params.session_id ||
          this.form.props.match.params.session_id.trim() == ''
        ) {
          //no session ID, so we need to create one here
          this.form.props.match.params.session_id = uuid();
        }

        let failedUploads = {}; // Define a list of keys that failed to upload

        let answer_data_forSubmit = await this.form.traverseAndFlatten(
          answer_data,
          'SUBMIT',
          reqId,
          failedUploads
        );

        let answer_data_formSession = JSON.parse(
          JSON.stringify(answer_data_forSubmit)
        );

        let data = await this.form.traverseAndFlatten(
          answer_data_formSession,
          'SUBMIT_SESSION',
          reqId,
          failedUploads
        );

        const { session_id, form_id, test_id } = this.form.props.match.params;

        const isTest = test_id !== undefined;

        let sessionURL = `${config.API_ADDRESS}/form_session?session_id=${session_id}&form_id=${form_id}`;

        if (isTest) {
          sessionURL = `${config.API_ADDRESS}/test_form_session?session_id=${session_id}&form_id=${form_id}`;
        }

        let projectSessionId = this.form.state.projectSessionId;
        if (this.form.state.formType === 'form') {
          // If it's a trigger form
          projectSessionId = reqId;
        }

        // Handle files failing to upload on submission here
        if (failedUploads && Object.keys(failedUploads).length > 0) {
          const saveData = data ? { ...data } : {}; // Make a copy of the data

          // Remove the failed uploads from the save data
          Object.keys(failedUploads).map((key) => {
            if (key in saveData) delete saveData[key];
          });

          // Perform the save
          let hasSaveFailed = false;
          try {
            const formSessionID = this.form.props.match.params.session_id;
            await this.form.makeFormSaveRequest(
              sessionURL,
              saveData,
              formSessionID
            );

            // Handle changing URL
            let formSessionURL = `/form/${this.form.props.match.params.form_id}/${formSessionID}`;
            if (test_id !== undefined)
              formSessionURL = `/form/form_test/${this.form.props.match.params.form_id}/${test_id}/${formSessionID}`;
            this.form.props.history.push(formSessionURL);
          } catch (e) {
            console.log(e);
            hasSaveFailed = true;
          }

          // Open submission error dialog
          this.form.setState({
            formFailures: { failedUploads, failedSave: hasSaveFailed },
            showFailedSubmissionDialog: true,
          });
          this.form.handleErrorState();

          return;
        }

        // Set submitted by
        data['submittedBy'] = {
          userName: this.form.state.userName,
          displayName: this.form.state.displayName,
        };

        axios(sessionURL, {
          method: 'post',
          data: {
            data: data,
            session_id: this.form.props.match.params.session_id,
            form_id: this.form.props.match.params.form_id,
            password: this.form.state.password,
            isSingleUse: this.form.state.isSingleUse,
            submissionId: reqId,
            canReadOnly: this.form.state.canReadOnly,
            projectId: this.form.state.projectId,
            projectVersion: this.form.state.projectVersion,
            projectSessionId: projectSessionId,
            parentThreadId: this.form.state.parentThreadId,
            threadId: this.form.state.threadId,
            latestTestProjectSessionId: reqId,
            waitingStateThreadId: this.form.state.waitingStateThreadId,
            waitingStateParentThreadId:
              this.form.state.waitingStateParentThreadId,
          },
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        })
          .then(async (res) => {
            return this.submitForm(reqId, answer_data_forSubmit);
          })
          .then((data) => {
            let hasRedirected = false;

            if (
              this.form.state.receiptState &&
              this.form.state.receiptState == 'hidden'
            ) {
              if (this.form.state.linkedComponent && reqId) {
                let projectSessionId = reqId;

                if (
                  this.form.state.projectSessionId &&
                  this.form.state.projectSessionId != ''
                ) {
                  projectSessionId = this.form.state.projectSessionId;
                }

                if (isTest) {
                  this.form.props.history.push(
                    `/form_test/${this.form.props.match.params.form_id}/${this.form.props.match.params.session_id}/${projectSessionId}/${test_id}`
                  );
                } else {
                  this.form.props.history.push(
                    `/form/${this.form.props.match.params.form_id}/${this.form.props.match.params.session_id}/${projectSessionId}`
                  );
                }

                hasRedirected = true;
                return;
              }
            }

            if (!hasRedirected) {
              if (!isTest) {
                this.form.props.history.push(
                  '/form/' +
                    this.form.props.match.params.form_id +
                    '/' +
                    this.form.props.match.params.session_id
                );
              } else {
                this.form.props.history.push(
                  '/form/form_test/' +
                    form_id +
                    '/' +
                    test_id +
                    '/' +
                    session_id
                );
              }
            }
          })
          .then(() => {
            this.form.setState((state) => {
              return { currentStep: 1, pageProcessing: false };
            });
          })
          .catch((e) => {
            console.log(e);
            this.form.setState((state) => {
              return {
                currentStep: 1,
                receiptState: 'failure',
                response: true,
                finished: true,
                sended: false,
                isSubmitting: false,
              };
            });
          });
      } catch (e) {
        this.form.handleErrorState(e);
      }
    }
  }
}

export default FormSubmissionHandler;
